/**
 * Calculate final price
 * @param {Number} price
 * @return {Number} price rounded to 2 digits
 * @namespace Util/Price/roundPrice
 */
export const roundPrice = (price, digits = 0) => {
  return parseFloat(price).toFixed(digits)
}
